export default "__VITE_ASSET__02IFOYDC__"